import { useEffect, useState } from "react";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import AvailableSlot from "../AvailableSlot/AvailableSlot";
import { getMentorSessionForUser } from "../../../ApiServices/ApiServices";
import "./MentorPricing.css";
import Message from "./Message";
import ChatIcon from "@mui/icons-material/Chat";
import ShareIcon from "@mui/icons-material/Share";
import { handleError } from "../../../Utils";
import { useNavigate } from "react-router-dom";

const MentorPricing = ({ id, mentorName, profileImage }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isPriorityDMVisible, setIsPriorityDMVisible] = useState(false);
  const [selectedPriceIndex, setSelectedPriceIndex] = useState(null);
  const [sessionType, setSessionType] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const getMentorSessionsForUser = async () => {
      try {
        if(!id) return ;
        const response = await getMentorSessionForUser(id);
        setSessionType(response.sessions);
      } catch (error) {
        return handleError(error?.response?.data?.message);
      }
    };
    getMentorSessionsForUser();
  }, [id]);

  const handlePopUp = (index) => {
    setSelectedPriceIndex(index);
    if (sessionType[index].type === "DM") {
      // setIsPriorityDMVisible(true);
      navigate("/priority-dm", {
        state: {
          mentorId: id,
          selectedPriceIndex : index,
          mentorName: mentorName,
          sessionType,
          profileImage,
        },
      });
    }else if(sessionType[index]?.type === "Referral"){
      navigate("/referral-request", {
        state: {
          mentorId: id,
          selectedPriceIndex : index,
          mentorName: mentorName,
          sessionType,
          profileImage,
        },
      });
    } else {
      setIsVisible(true);
    }
  };

  return (
    <>
      <h2 className="book-your-session text-2xl">Book Session Now</h2>
      <div className="mentor-pricing flex">
        {sessionType.map((item, index) => {
          return (
            <div
              className="mentor-pricing-card flex-col"
              key={index}
              onClick={() => handlePopUp(index)}
            >
              <div className="mentor-pricing-type">{item.title}</div>
              <div className="mentor-pricing-price flex">
                <div className="flex">
                  {(() => {
                  let IconComponent = CalendarMonthIcon;
                  let planText = `${item?.duration} mins`;
                  let typeLabel = "Video Meeting";

                  if (item?.type === "DM") {
                    IconComponent = ChatIcon;
                    planText = "Reply in two days";
                    typeLabel = "DM";
                  } else if (item?.type === "Referral") {
                    IconComponent = ShareIcon;
                    planText = "Reply in two days";
                    typeLabel = "Referral";
                  }

                  return (
                    <>
                      <IconComponent className="icon" />
                      <div className="video-meeting">
                        <div className="time">{planText}</div>
                        <div>{typeLabel}</div>
                      </div>
                    </>
                  );
                })()}
                </div>
                <div className="price-value">
                  ₹{item.amount}
                  <ArrowForwardIcon />
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Show pop-up for "Priority DM" with message input */}
      {isPriorityDMVisible && (
        <Message
          setIsPriorityDMVisible={setIsPriorityDMVisible}
          mentorName={mentorName}
          profileImage={profileImage}
          id={id}
        />
      )}

      {/* Show Available Slot pop-up for other sessions */}
      {isVisible && (
        <AvailableSlot
          isVisible={isVisible}
          setIsVisible={setIsVisible}
          id={id}
          selectedPriceIndex={selectedPriceIndex}
          mentorName={mentorName}
          sessionType={sessionType}
          profileImage={profileImage}
        />
      )}
    </>
  );
};

export default MentorPricing;
